import { Component } from '@angular/core';
import { ChartConfiguration, ChartOptions } from 'chart.js';

@Component({
  selector: 'app-bank-analytics',
  templateUrl: './bank-analytics.component.html',
  styleUrls: ['./bank-analytics.component.css'],
})
export class BankAnalyticsComponent {
  //Line Chart Data

  public transcationLineChartData: ChartConfiguration<'line'>['data'] = {
    labels: ['05:00', '10:00', '15:00', '20:00', '25:00', '30:00'],
    datasets: [
      {
        data: [0.1, 0.2, 0.1, 0.2, 0.1, 0.3, 0.1, 0.5],
        label: 'Series A',
        borderColor: 'silver',
        backgroundColor: 'transparent',
        borderWidth: 4,
        borderDash: [5, 5],
        tension: 0.4,
      },
      {
        data: [0.1, 0.2, 0.3, 0.1, 0.2],
        label: 'Series B',
        borderColor: 'purple',
        backgroundColor: 'transparent',
        borderWidth: 4,
        tension: 0.4,
      },
    ],
  };

  public apiUsageLineChartData: ChartConfiguration<'line'>['data'] = {
    labels: ['05:00', '10:00', '15:00', '20:00', '25:00', '30:00'],
    datasets: [
      {
        data: [0.1, 0.2, 0.3, 0.1, 0.2],
        label: 'Series A',
        borderColor: 'purple',
        backgroundColor: 'transparent',
        borderWidth: 4,
        tension: 0.4,
      },
    ],
  };

  //Bar Chart

  public userRegistrationBarChartData: ChartConfiguration<'bar'>['data'] = {
    labels: ['Partner 1', 'Partner 2', 'Partner 3'],
    datasets: [
      { data: [3, 4.5, 7], label: 'Partner A', backgroundColor: '#0058e9' },
    ],
  };

  public serviceBarChartData: ChartConfiguration<'bar'>['data'] = {
    labels: ['Service 1', 'Service 2', 'Service 3'],
    datasets: [
      { data: [8, 7, 9], label: 'Service A', backgroundColor: '#0058e9' },
    ],
  };

  //Pie Chart

  public pieChartOptions: ChartOptions<'pie'> = {
    responsive: false,
    plugins: {
      legend: {
        position: 'right',
      },
    },
  };
  public pieChartLabels = ['Completed', 'Pending', 'Rejected'];
  public pieChartDatasets = [
    {
      data: [500, 100, 100],
      backgroundColor: ['#0CAF60', '#C0A145', '#FF3A6E'],
    },
  ];
  public pieChartPlugins:any = [];
}
